<template>
  <div>
    <p v-if="isWorkloadsManager">
      Click <router-link :to="{ name: 'workloads' }">here</router-link> to view
      current workloads.
    </p>
    <div v-if="isWorkloadsSubmitter">
      <div class="row">
        <div class="col-md-6" style="vertical-align: text-bottom">
          <div class="card" style="height: 100%">
            <div class="card-body">
              <h5 class="card-title">
                {{ currentTimePeriod ? currentTimePeriod.description : "" }}
              </h5>
              <div v-if="currentTimePeriodWorkload">
                <b-alert
                  show
                  :variant="statusAlertVariant(currentTimePeriodWorkload)"
                  class="my-2 mx-2"
                  v-if="currentTimePeriodWorkload.currentStatus"
                >
                  <span
                    >Current Status:
                    <span class="font-weight-bold">{{
                      currentTimePeriodWorkload.currentStatus
                        .workloadStatusDefinition.name
                    }}</span></span
                  >
                  <div
                    v-if="currentTimePeriodWorkload.currentStatus.notes"
                    class="mx-4"
                  >
                    <hr />
                    Comments:
                    <span class="font-italic">{{
                      currentTimePeriodWorkload.currentStatus.notes
                    }}</span>
                  </div>
                </b-alert>

                <div>
                  <workload-type-summary
                    :workload-types="currentTimePeriodWorkload.workloadTypes"
                  ></workload-type-summary>
                </div>
              </div>
            </div>
            <div class="card-footer text-muted">
              <b-button
                variant="primary"
                :to="{
                  name: 'workloadAdd',
                  query: { timePeriod: currentTimePeriod.timePeriodId },
                }"
                v-if="!currentWorkload && currentTimePeriod"
                class="mx-1"
              >
                Enter Current Workload<br />({{
                  currentTimePeriod ? currentTimePeriod.description : ""
                }})
              </b-button>
              <b-button
                variant="primary"
                :to="{
                  name: 'workloadEdit',
                  params: { workloadId: currentWorkload.workloadId },
                }"
                v-if="currentWorkload && currentTimePeriod"
                class="mx-1"
              >
                Edit Current Workload<br />({{
                  currentTimePeriod ? currentTimePeriod.description : ""
                }})
              </b-button>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="card" style="height: 100%">
            <div class="card-body" v-if="!showNextTimePeriod">
              <div class="alert alert-info" role="alert">
                <div class="font-weight-bold h5">Important Note:</div>
                The next workload year will be available on
                {{ nextTimePeriodOpenDate }}.
              </div>
            </div>
            <div v-else class="card-body">
              <h5 class="card-title">
                {{ nextTimePeriod ? nextTimePeriod.description : "" }}
              </h5>

              <div v-if="nextTimePeriodWorkload">
                <b-alert
                  show
                  :variant="statusAlertVariant(nextTimePeriodWorkload)"
                  class="my-2 mx-2"
                  v-if="nextTimePeriodWorkload.currentStatus"
                >
                  <span
                    >Current Status:
                    <span class="font-weight-bold">{{
                      nextTimePeriodWorkload.currentStatus
                        .workloadStatusDefinition.name
                    }}</span></span
                  >
                  <div
                    v-if="nextTimePeriodWorkload.currentStatus.notes"
                    class="mx-4"
                  >
                    <hr />
                    Comments:
                    <span class="font-italic">{{
                      nextTimePeriodWorkload.currentStatus.notes
                    }}</span>
                  </div>
                </b-alert>

                <b-container>
                  <workload-type-summary
                    :workload-types="nextTimePeriodWorkload.workloadTypes"
                  ></workload-type-summary>
                </b-container>
              </div>
            </div>
            <div v-if="showNextTimePeriod" class="card-footer text-muted">
              <b-button
                variant="primary"
                :to="{
                  name: 'workloadAdd',
                  query: { timePeriod: nextTimePeriod.timePeriodId },
                }"
                v-if="!nextWorkload && nextTimePeriod"
                class="mx-1"
              >
                Enter Next Year's Workload<br />({{
                  nextTimePeriod ? nextTimePeriod.description : ""
                }})
              </b-button>
              <b-button
                variant="primary"
                :to="{
                  name: 'workloadEdit',
                  params: { workloadId: nextWorkload.workloadId },
                }"
                v-if="nextWorkload && nextTimePeriod"
                class="mx-1"
              >
                Edit Next Year's Workload<br />({{
                  nextTimePeriod ? nextTimePeriod.description : ""
                }})
              </b-button>
            </div>
          </div>
        </div>
      </div>

      <div v-if="userWorkloads.length" class="mt-5">
        <b-btn
          @click="viewPastWorkloads = !viewPastWorkloads"
          class="previous-workload-button"
        >
          {{
            viewPastWorkloads
              ? "Hide Previous Workloads"
              : "Show Previous Workloads"
          }}
        </b-btn>
        <b-collapse
          v-model="viewPastWorkloads"
          class="mt-2"
          id="workload-collapse"
        >
          <b-table
            striped
            hover
            small
            :fields="workloadFields"
            :items="userWorkloads"
            sort-desc
          >
            <template v-slot:cell(startTerm)="data">
              {{ getStartTerm(data.item).term.description }}
            </template>
            <template v-slot:cell(endTerm)="data">
              {{ getEndTerm(data.item).term.description }}
            </template>
            <template v-slot:cell(effectiveDate)="data">
              {{ data.item.effectiveDate | formatDate }}
            </template>
            <template
              v-for="workloadTypeDefinition in workloadTypeDefinitions"
              v-slot:[getCell(workloadTypeDefinition.name)]="data"
            >
              {{
                getWorkloadType(
                  data.item.workloadTypes,
                  workloadTypeDefinition.workloadTypeDefinitionId,
                )
                  ? getWorkloadType(
                      data.item.workloadTypes,
                      workloadTypeDefinition.workloadTypeDefinitionId,
                    ).value
                  : 0 | percentage(0)
              }}
            </template>
            <template v-slot:cell(details)="data">
              <router-link
                :to="{
                  name: 'workload',
                  params: { workloadId: data.item.workloadId },
                }"
                >Details</router-link
              >
            </template>
          </b-table>
        </b-collapse>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
// import DoughnutChart from "../../components/charts/CustomDoughnutChart";
import WorkloadTypeSummary from "../../components/workloads/workload-type-summary.vue";
import roleChecks from "../../misc/role-checks";
import * as _ from "lodash"; // eslint-disable-line no-unused-vars

export default {
  mixins: [roleChecks],
  data() {
    return {
      viewPastWorkloads: false,
      workloadFields: [
        { key: "startTerm", sortable: true },
        { key: "endTerm", sortable: true },
        { key: "effectiveDate", sortable: true },
        {
          key: "currentStatus.workloadStatusDefinition.name",
          label: "Status",
          sortable: true,
        },
        { key: "details", label: "" },
      ],
      colors: [
        "rgba(255, 99, 132, 0.2)",
        "rgba(54, 162, 235, 0.2)",
        "rgba(255, 206, 86, 0.2)",
        "rgba(75, 192, 192, 0.2)",
        "rgba(153, 102, 255, 0.2)",
        "rgba(255, 159, 64, 0.2)",
      ],
      borderColors: [
        "rgba(255,99,132,1)",
        "rgba(54, 162, 235, 1)",
        "rgba(255, 206, 86, 1)",
        "rgba(75, 192, 192, 1)",
        "rgba(153, 102, 255, 1)",
        "rgba(255, 159, 64, 1)",
      ],
      singleColors: ["#8c1d40", "#ffcb66"],
      singleBorderColors: ["#70112f", "#70112f"],
      chartOptions: {
        legend: {
          position: "top",
        },
      },
      nextTimePeriodOpenMonthAndDay: "02-01",
    };
  },

  components: {
    WorkloadTypeSummary,
  },

  watch: {
    user: function () {
      this.updateWorkloads();
    },
  },

  computed: {
    ...mapState({
      user: (state) => state.auth.user,
      currentTimePeriod: (state) => state.status.currentTimePeriod,
      currentWorkload: (state) => state.status.currentWorkload,
      nextTimePeriod: (state) => state.status.nextTimePeriod,
      nextWorkload: (state) => state.status.nextWorkload,
      workloadTypeDefinitions: (state) =>
        state.workloads.workloadTypeDefinitions,
      userWorkloads: (state) => state.workloads.userWorkloads,
    }),

    nextTimePeriodOpenDate: function () {
      if (this.nextTimePeriod && this.nextTimePeriod.description) {
        return (
          this.nextTimePeriod.description.split("-")[0] +
          "-" +
          this.nextTimePeriodOpenMonthAndDay
        );
      }
      return "";
    },

    showNextTimePeriod: function () {
      if (this.nextTimePeriod && this.nextTimePeriod.description) {
        // hide the next time period if the current date is prior to March 1 of the time period year
        const currentDate = new Date();
        const startDate = new Date(this.nextTimePeriodOpenDate);
        return currentDate >= startDate;
      }
      return false;
    },

    currentTimePeriodWorkload: function () {
      var that = this;
      if (this.currentTimePeriod) {
        var wl = _.find(this.userWorkloads, function (workload) {
          return workload.timePeriodId === that.currentTimePeriod.timePeriodId;
        });

        return wl;
      }
    },

    nextTimePeriodWorkload: function () {
      var that = this;
      if (this.nextTimePeriod) {
        return _.find(this.userWorkloads, function (workload) {
          return workload.timePeriodId === that.nextTimePeriod.timePeriodId;
        });
      }
    },

    approvedWorkloads: function () {
      return _.filter(this.userWorkloads, function (workload) {
        return (
          workload.currentStatus.workloadStatusDefinition.name === "Approved"
        );
      });
    },

    unapprovedWorkloads: function () {
      return _.filter(this.userWorkloads, function (workload) {
        return (
          workload.currentStatus.workloadStatusDefinition.name != "Approved"
        );
      });
    },

    totalPercentage: function () {
      var total = 0;
      if (this.currentTimePeriodWorkload) {
        _.forEach(
          this.currentTimePeriodWorkload.workloadTypes,
          function (workloadType) {
            console.log("here!!!!!!!!!!!!!!!");
            console.log(workloadType.value);
            console.log("***************");
            total = workloadType.value;
          },
        );
      }
      return total;
    },
  },

  methods: {
    ...mapActions("status", [
      "getCurrentTimePeriod",
      "getCurrentWorkload",
      "getNextTimePeriod",
      "getNextWorkload",
    ]),

    ...mapActions("workloads", [
      "getAllWorkloadsByAsurite",
      "getWorkloadTypeDefinitions",
    ]),

    getCell(key) {
      return `cell(${key})`; // simple string interpolation
    },

    makeSingleChart: function (workloadType) {
      var that = this;

      if (workloadType) {
        var formattedData = {
          labels: [],
          legend: {
            display: false,
          },
          options: {
            legend: {
              display: false,
            },
          },
          datasets: [
            {
              backgroundColor: [],
              borderColor: [],
              borderWidth: 1,
              data: [],
            },
          ],
        };

        var values = [
          workloadType,
          {
            value: 1 - workloadType.value,
            workloadTypeDefinition: {
              name: "Total time",
            },
          },
        ];

        var colorIndex = 0;
        _.forEach(values, function (type) {
          if (type.workloadTypeDefinition.name !== "Total time") {
            formattedData.labels.push(type.workloadTypeDefinition.name);
          }

          formattedData.datasets[0].data.push(type.value * 100);
          formattedData.datasets[0].backgroundColor.push(
            that.singleColors[colorIndex],
          );
          formattedData.datasets[0].borderColor.push(
            that.singleBorderColors[colorIndex],
          );
          if (colorIndex < that.colors.length - 1) {
            colorIndex++;
          } else {
            colorIndex = 0;
          }
        });

        return formattedData;
      }
      return null;
    },

    makeChart: function (workload) {
      var that = this;

      if (workload) {
        var formattedData = {
          labels: [],
          legend: {
            display: false,
          },
          options: {
            legend: {
              display: false,
            },
          },
          datasets: [
            {
              backgroundColor: [],
              borderColor: [],
              borderWidth: 1,
              data: [],
            },
          ],
        };

        var colorIndex = 0;
        _.forEach(workload.workloadTypes, function (type) {
          formattedData.labels.push(type.workloadTypeDefinition.name);
          formattedData.datasets[0].data.push(type.value);
          formattedData.datasets[0].backgroundColor.push(
            that.colors[colorIndex],
          );
          formattedData.datasets[0].borderColor.push(
            that.borderColors[colorIndex],
          );
          if (colorIndex < that.colors.length - 1) {
            colorIndex++;
          } else {
            colorIndex = 0;
          }
        });

        return formattedData;
      }
      return null;
    },

    statusAlertVariant: function (workload) {
      if (workload.currentStatus) {
        if (
          workload.currentStatus.workloadStatusDefinition.name === "Approved"
        ) {
          return "success";
        }
        if (workload.currentStatus.workloadStatusDefinition.name === "Denied") {
          return "danger";
        }
        if (
          workload.currentStatus.workloadStatusDefinition.name === "Resubmit"
        ) {
          return "warning";
        }
      }
      return "info";
    },

    // need to figure out the date range from the description, because AcadYear in the db doesn't seem to be reliable?
    getWorkloadRange(term) {
      var year = parseInt(term.description.substring(0, 4));
      var startYear = year;
      var endYear = year;
      if (
        term.description.includes("Fall") ||
        term.description.includes("Winter")
      ) {
        endYear = year + 1;
      } else {
        startYear = year - 1;
      }
      return startYear + "-" + endYear;
    },

    updateWorkloads: function () {
      var that = this;

      this.getAllWorkloadsByAsurite(this.user.userId).catch(function (error) {
        console.log(error);
      });

      this.getCurrentTimePeriod().then(function () {
        that.getCurrentWorkload();
      });
      this.getNextTimePeriod().then(function () {
        that.getNextWorkload();
      });
    },

    addWorkloadTypeFields() {
      var that = this;

      _.forEach(
        this.workloadTypeDefinitions,
        function (workloadTypeDefinition) {
          var newField = {
            key: workloadTypeDefinition.name,
            label: workloadTypeDefinition.name,
            sortable: true,
          };
          that.workloadFields.splice(-1, 0, newField);
        },
      );
    },

    getWorkloadType(workloadTypes, workloadTypeDefinitionId) {
      return _.find(workloadTypes, function (workloadType) {
        return (
          workloadType.workloadTypeDefinitionId === workloadTypeDefinitionId
        );
      });
    },

    getStartTerm: function (workload) {
      var startTerm = _.sortBy(
        workload.timePeriod.timePeriodTerms,
        function (timePeriodTerm) {
          return timePeriodTerm.term.termStart;
        },
      )[0];
      return startTerm;
    },

    getEndTerm: function (workload) {
      var endTerm = _.sortBy(
        workload.timePeriod.timePeriodTerms,
        function (timePeriodTerm) {
          return timePeriodTerm.term.termEnd;
        },
      )[workload.timePeriod.timePeriodTerms.length - 1];
      return endTerm;
    },
  },

  created() {
    var that = this;

    this.updateWorkloads();

    this.getWorkloadTypeDefinitions().then(function () {
      that.addWorkloadTypeFields();
    });
  },
};
</script>

<style scoped></style>
